var numOfQuestions       = 0;

jQuery(document).ready(function($) {

  // ajax get json file
  $.ajax({
    url: '/wp-content/themes/custom/bricktimber/src/components/03-organisms/quiz/quiz-questions.json',
    dataType: 'json',
    type: 'get',
    cache: false,
    success: getQuestions,
    error:function(){
            // failed request; give feedback to user
            $('#quiz').html('<p class="data-load-error"><strong>Oops!</strong> Data transfer failure, please refresh your page </p>');
          }
    });

// Get questions and populate HTML
function getQuestions(data) {
  var Questions = [];

  $(data.questions).each(function(index, value) {
     Questions.push(value.question);
  });
  populateHTML(Questions);
}

//get and print questions in HTML document
function populateHTML(questions) {
      $(questions).each(function(index, question) {
        //get question type,
        //question object and index *(index of question in array)
        var type        =  question.type;
        var question    =  question;

        //print questions and alternative questions
        if ( type == 'selection' || type == 'selection alt-q' ) {

          printSelectionQuestion(question);
        }

        else if ( type == 'multiple-selection' || type == 'multiple-selection alt-q' ) {

          printMultipleSelectionQuestion(question);
        }

        else if ( type == 'slider-selection' || type == 'slider-selection alt-q' ) {

          printSliderQuestion(question);
        }

        else if ( type == 'image-selection' || type == 'image-selection alt-q' ) {

          printImageSelectionQuestion(question);
        }

        else if ( type == 'term' || type == 'term alt-q' ) {

          printTermQuestion(question);
        }
        else if ( type == 'sortable' || type == 'sortable alt-q' ) {

          printSortableQuestion(question);
        }
      });
    }
// get selection question
function printSelectionQuestion(question) {
  var htmlprint = '<form class=" ' + question.type + ' col-sm-12">'+
                '<div class="question-title">'+ ( question.questionTitle || '' ) + '</div>' +
                '<div class="question-text">'+
                 '<p>' + question.questionText + '</p>'+
              '</div>';
  htmlprint += '<ul>';

  for (var i = 0; i < question.choices.length; i++) {
  htmlprint += '<li><label><input type="radio" name="answer" data-value=' + question.answer[i] + '><i></i>' + question.choices[i] + '</label></li>';
  }

  htmlprint += '</ul>';
  htmlprint += '<div class="msg-correct" style="display:none">' + question.correctMsg +'</div>';
  htmlprint += '<div class="msg-incorrect" style="display:none">' + question.incorrectMsg +'</div>';
  htmlprint += '</form>';
  
  // $('#level' + question.level + ' .message').before(htmlprint);
}

// get multiple selection question
function printMultipleSelectionQuestion(question) {

  htmlprint = '<form class=" ' + question.type + ' col-sm-12" ">'+
                '<div class="question-title">'+ ( question.questionTitle || '' ) + '</div>' +
                '<div class="question-text">'+
                 '<p>' + question.questionText + '</p>'+
              '</div>';
  htmlprint += '<ul>';

  for (var i = 0; i < question.choices.length; i++) {
  htmlprint += '<li><label><input type="checkbox" name="answer" data-value=' + question.answer[i] + '><i></i>' + question.choices[i] + '</label></li>';
  }

  htmlprint += '</ul>';

  htmlprint += '<div class="msg-correct" style="display:none">' + question.correctMsg +'</div>';
  htmlprint += '<div class="msg-incorrect" style="display:none">' + question.incorrectMsg +'</div>';

  htmlprint += '</form>';

  $('#level' + question.level + ' .message').before(htmlprint);
}

// get slider question
function printSliderQuestion(question) {
  //generate unique random id
    var rnd = new randomGenerator(1,5000);
    var id =rnd.get();

  htmlprint = '<form class=" ' + question.type + ' col-sm-12" ">'+
                '<div class="question-title">'+ ( question.questionTitle || '' ) + '</div>' +
                '<div class="question-text">'+
                 '<p>' + question.questionText + '</p>'+
                 '<label>' + question.questionHint + '</label>'+
              '</div>';
  htmlprint +=  '<p><input type="text" id="amount' + id + '"class="amount" readonly></p>'+
                '<div id="slider' + id + '"class="slider" data-value=' + question.answer + '></div>';

  htmlprint += '<div class="slider-value-min"> '+ question.min +' </div>'+
                '<div class="slider-value-mid"> '+ sliderMiddleValue(question.max,question.min) +' </div>'+
                '<div class="slider-value-max"> '+ question.max +' </div>';

  htmlprint += '<div class="msg-correct" style="display:none">' + question.correctMsg +'</div>';
  htmlprint += '<div class="msg-incorrect" style="display:none">' + question.incorrectMsg +'</div>';

  htmlprint += '</form>';

  $('#level' + question.level + ' .message').before(htmlprint);

//initialize slider
  $( "#slider" + id ).slider({
        //value: question.value,
        min: question.min,
        max: question.max,
        step: question.step,
        slide: function( event, ui ) {
          $( "#amount"+ id ).val( ui.value );
          $( '.ui-slider-handle' ).text( ui.value );
        }
      });
      $( "#amount" + id ).val( $( "#slider" + id ).slider( "value" ) );

}

//get image selection question
function printImageSelectionQuestion(question) {

  htmlprint = '<form class=" ' + question.type + '  col-sm-12"">'+
                '<div class="question-title">'+ ( question.questionTitle || '' ) + '</div>' +
                '<div class="question-text">'+
                 '<p>' + question.questionText + '</p>'+
              '</div>';

  //if single choice question print radio buttons
  if ( numberOfAnswers(question.answer) == 1 ) {

      for (var i = 0; i < question.choices.length; i++) {
      htmlprint += '<label class="col-md-6"><input type="radio" name="answer" data-value=' + question.answer[i] + '>' +
                    '<img class="img-responsive" src="'+ question.choices[i] + '"></label>';
      }

  }
  //if multichoice print check boxes
  else {

      for (var i = 0; i < question.choices.length; i++) {
      htmlprint += '<label><input type="checkbox" name="answer" data-value=' + question.answer[i] + '>' +
                  '<img src="'+ question.choices[i] + '"></label>';
      }

  }
  htmlprint += '<div class="msg-correct" style="display:none">' + question.correctMsg +'</div>';
  htmlprint += '<div class="msg-incorrect" style="display:none">' + question.incorrectMsg +'</div>';

  htmlprint += '</form>';

  $('#level' + question.level + ' .message').before(htmlprint);

}

//get term question
function printTermQuestion(question) {

  htmlprint = '<form class="' + question.type + ' col-sm-12"">'+
                '<div class="question-title">'+ ( question.questionTitle || '' ) + '</div>' +
                '<div class="question-text">'+
                 '<p>' + question.questionText + '</p>'+
                 '<label>' + question.questionHint + '</label>'+
              '</div>';
  htmlprint += '<label><input type="text" name="answer" data-value=' + question.answer + '></label>';

  htmlprint += '<div class="msg-correct" style="display:none">' + question.correctMsg +'</div>';
  htmlprint += '<div class="msg-incorrect" style="display:none">' + question.incorrectMsg +'</div>';

  htmlprint += '</form>';

  $('#level' + question.level + ' .message').before(htmlprint);
}

//get sortable question
function printSortableQuestion(question) {
  htmlprint = '<form class="' + question.type + ' col-sm-12"">'+
                '<div class="question-title">'+ ( question.questionTitle || '' ) + '</div>' +
                '<div class="question-text">'
                  + question.questionText +
              '</div><div class=drags><h3>Terms:</h3>';
for (var i = 0; i < question.choices.length; i++) {
  htmlprint += '<div class="retrieve-container"><div class="drag"><span data-value=' + question.answer[i] + '>' + question.choices[i] + '</span></div></div>';
}

  htmlprint += '</div>';

  htmlprint += '<div class="msg-correct" style="display:none">' + question.correctMsg +'</div>';
  htmlprint += '<div class="msg-incorrect" style="display:none">' + question.incorrectMsg +'</div>';

  htmlprint += '</form>';

  $('#level' + question.level + ' .message').before(htmlprint);

  //initialize sortable (dragable/droppable containers)
  $('.drag').draggable({
                  helper:"clone",
                  revert: "invalid",
                  containment:"document"
  });

  $('.droppable').droppable({
          drop:function(event, ui) {
              ui.draggable.parent().droppable("enable");
              ui.draggable.detach().appendTo($(this));
              //prevent multiple .drag drops (BUG FIX)
              $(this).droppable( "disable");
          }
  });

  //init retrieve container for resorting
  $('.retrieve-container').droppable({
          drop:function(event, ui) {
              //if container empty enable drop
              if(!$(this).children().length) {
                  ui.draggable.parent().droppable("enable");
                  ui.draggable.detach().appendTo($(this));
              }
              //disable drop (prevent multiple elements in one container)
              else {
                $(this).droppable( "disable");
              }
          }
  });

}

//check if miltichoice answer question or not
function numberOfAnswers(answers) {
  var num = 0;
  for (var i = 0; i < answers.length; i++) {
    num += answers[i];
  }
  return num;
}

//last word in string
function lastWord(words) {
    var n = words.split(" ");
    return n[n.length - 1];
}
//first word in string
function firstWord(words) {
    var n = words.split(" ");
    return n[0];
}

//*RANDOMIZATION*//
function randomGenerator(low, high) {
    if (arguments.length < 2) {
        high = low;
        low = 0;
    }
    this.low = low;
    this.high = high;
    this.reset();
}

randomGenerator.prototype = {
    reset: function() {
        this.remaining = [];
        for (var i = this.low; i <= this.high; i++) {
            this.remaining.push(i);
        }
    },
    get: function() {
        if (!this.remaining.length) {
            this.reset();
        }
        var index = Math.floor(Math.random() * this.remaining.length);
        var val = this.remaining[index];
        this.remaining.splice(index, 1);
        return val;
    }
}

// get main questions by random order
function getRandomMainQuestions(mainQuestions, randOrder) {
    var questions = [];
      for (var i = 0; i < randOrder.length; i++) {
        for (var j = 0; j < mainQuestions.length; j++) {
            if ( (randOrder[i]-1) == [j]) {
              questions.push(mainQuestions[j]);
            }
        }
      }
      return questions;
}

// get alternative questions from temp array and return full HTML printable array
function getAlternativeQuestions(altQuestions, temp, lmt) {
    var questions = [];
    var altQ = altQuestions;
    var lmtCounter = 1;

     $(temp).each(function(i ,value) {
      lmtCounter = 1;
      questions.push(value);

        $(altQ).each(function(j, val) {
            var typeStart = firstWord(val.type);

            if (value.type == typeStart) {
              if (lmtCounter <= lmt) {
                  // push this question in questions array (return for HTML printing)
                  questions.push(val);
                  // remove this question from altQ array (to prevent repetition of questions)
                  altQ.splice(j,1);
                  lmtCounter++;
              }
            }
        });
     });
      return questions;
}

//Slider middle value
function sliderMiddleValue(max,min) {
  if (min == 0 && max > 0) {
    return max/2;
  }
  else {
    return (max+min)/2;
  }
}

    //Global counters
    var activeLevel          = "";
    var numberOfQuestions    = "";
    var currentQuestion      = 0;
    var currentLevel         = 0;

    var termCounter = 1;
    var numberOfTerms = 0;

    //Header level info label
    var $levelInfo = $('#lvl-info');

    //Global progress bar obj.
    var $mainProgressBar      = $('#progressbar');
    $mainProgressBar.progressbar({
      value: 0,
    });
    var $mainProgressBarNo    = $('.progres-number');
    var $modalProgressBar     = $('#modalprogressbar');
    var $modalProgressBarNo   = $('.modalprogres-number');

    //Dinamic Modals
    var $videoModal     = $('#videoModal');
    var $termsModal     = $('#termsModal');
    var modalOpend      = false;

    //Quiz statistics
    var numCorrectAnswers     = 0;
    var numIncorrectAnswers   = 0;

    var numOfTrys           = 0;
    var statisticDataObject = [];

    var timerStart          = "";
    var timerEnd            = "";
    var quizCanceled        = true;
    var quiz_started        = false;

    // Google Analytics question counter
    var GAQuestionCounter = 0;

    //On textbox enter press prevent page reload (BUG FIX)
    // $(window).keydown(function(event){
        // if( (event.keyCode == 13) && $('input').is(':focus') ) {
            // event.preventDefault();
            // return false;
        // }
    // });

    //Decorate Check Box text if selected
    $('body').on('click', 'input:radio[name="answer"]', function() {
        $('label').removeAttr('style');
        if (this.checked) {
            $(this).parent().css("font-weight","bold");
        }
    });

    //Statistic
    // On leave page or close, send data to statistics database
    window.onbeforeunload = function() {
        if (quizCanceled) {
            getQuizCompleteTime();
            console.log("Quiz is canceled!");
            // console.log(statisticDataObject);
        }

        // send data if user clicked on OK .start-quiz btn (quiz is started)
        if (quiz_started) {
            console.log("Send data to server");
            storeData();
        }
        // return undefined;
    }

    function storeData() {

      console.log('statisticDataObject');
      console.log(statisticDataObject);

      // Send score data
      $.ajax({
        url : '../wp-admin/admin-ajax.php',
        type : "POST",
        data : {
          action: "insert-quiz-score",
          sc: statisticDataObject,
        },
        success: function(response) {
          if(response == "success") {
            console.log('Stored user session');
          }
          else {
            console.log('Error attempting to store user session');
          }
        }
      });

        // $.ajax({
            // async: false,
            // url: "/quiz/ajax/ajax-insert-score.php",
            // type: "POST",
            // data: {sc : statisticDataObject}
        // });
    }

    // Spanish version ?
    var esp = "";
    // Quiz Start (Create anonimus user)
    $('.start-quiz').on('click', function () {
        // set quiz started
        quiz_started = true;
        //show header
        $('.header-content').removeAttr('style');
        //show progress bar
        $('.progres').removeAttr('style');

        // Check if spanish version of site
        var sub_domain = window.location.hostname.split('.').shift();

        if (sub_domain == "es") {
            // have cookie
            esp = 1;
        } else {
            // no cookie
            esp = 0;
        }
        
        // Send user data
        $.ajax({
          url : '../wp-admin/admin-ajax.php',
          type : "POST",
          data : {action: "insert-quiz-user"},
          success: function(response) {
            if(response == "success") {
              console.log('Stored user session');
            }
            else {
              console.log('Error attempting to store user session');
            }
          }
        });

        // Write initial quiz data to array
        statisticDataObject[currentQuestion] = numOfTrys;
        statisticDataObject[1] = 99;

        //google analitics spanish/english user
        if (esp) {
            // ga('send', 'event', 'Quiz Language', 'Spanish' , 'User came from');
        } else {
            // ga('send', 'event', 'Quiz Language', 'English' , 'User came from');
        }

        // Start Quiz timer
        timerStart = $.now();

        // return false;
    });

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    /*
    $('.signup-btn').on('click', function() {
        // Mailing list sign up
        eMail  = $("#email").val();

        // Remove storage functions since all is stored in WPCF7 database.

        if (validateEmail(eMail)) {
            // Show Thank you message & hide form input
            $('.super-badge').next('h3').text("Thank you for signing up to our newsletter");
            $('.form-email').hide();

        }
        return false;
    });
    */

    //Load first (or next) level
    $('.btn-lvlup').click( function() {
        $('body').removeClass('full-bgr');
        var $this = $(this);
        $this.parents().eq(1).removeClass('active').hide();

        var nextlevel = $this.parents().eq(1).next('section');
        activeLevel = nextlevel;
        nextlevel.addClass('active');
        // select first question
        nextlevel.children().first().addClass('current');
        currentQuestion ++;
        currentLevel++;

        //count regular questions in level
        numOfQuestions = countQuestions(nextlevel);

        numberOfQuestions = numOfQuestions;
        updateLevelCounter(currentLevel);
        updateProgressbar($mainProgressBar,$mainProgressBarNo,currentQuestion, numOfQuestions);

        //stop video (BUG FIX)
        $('.embed-responsive-item').attr('src','');
        //show video image
        $('.test-img img').css('display','block');

        //display level ifo
        $levelInfo.show();

        //if current question is sortable shuffle answers
        $('.sortable.current').randomize('.retrieve-container');

    });


    //travers thugh intros and append content to modal
    $('.btn-go').click(function () {
        var $this = $(this);
        var current = $this.parent().parent().removeClass('active').next().addClass('active');

        if (current.is('.start-level-video.active')) {

            //Clear video modal
            $videoModal.find(".modal-body").empty();

            //Append data to modal
            current.find('.head,.introduction, .test-img').clone(true).appendTo('#videoModal .modal-body');
        }
        else if (current.is('.start-level-terms.active')) {

            //Clear terms modal
            $termsModal.find(".modal-body").empty();

            //Append data to modal
            current.find('.terms')
                    .clone(true)
                    .appendTo('#termsModal .modal-body')
                    .removeClass('col-sm-12');

            //count terms and send to global
            numberOfTerms = current.find('.terms .term').children().length;

            //set progress bat to first term
            updateProgressbar($mainProgressBar,$mainProgressBarNo,1,numberOfTerms);

            //reset modal to first oppening
            modalOpend = false;
            //reset term counter
            termCounter = 1;
        }

    });

    //TERMS TRAVERSE
    $('.btn-nex-term').click(function () {
        var terms = $(this).parents('.terms');
        var nextTerm = terms.children(".term:visible").next(".term");

        termCounter++;

            if (nextTerm.length == 0) { // wrap around to beginning
              nextTerm = terms.find(".term:first");
              termCounter = 1;
            }

            terms.find(".term").hide();
            nextTerm.show();

            //update page main progressbar
            if (terms.parent().is('.start-level-terms.active')) {

                    updateProgressbar($mainProgressBar,$mainProgressBarNo,termCounter,numberOfTerms);
            }
            //update modal progressbar
            else if (terms.parent().is('.modal-body')) {

                    updateProgressbar($modalProgressBar,$modalProgressBarNo,termCounter,numberOfTerms);
            }
    });

    $('.btn-prev-term').click(function () {
        var terms = $(this).parents('.terms');
        var prevTerm = terms.children(".term:visible").prev(".term");

        termCounter--;

            if (prevTerm.length == 0) { // wrap around to beginning
              prevTerm = terms.find(".term:last");
              termCounter = numberOfTerms;
            }

            terms.find(".term").hide();
            prevTerm.show();

            //update page main progressbar
            if (terms.parent().is('.start-level-terms.active')) {

                    updateProgressbar($mainProgressBar,$mainProgressBarNo,termCounter,numberOfTerms);
            }
            //update modal progressbar
            else if (terms.parent().is('.modal-body')) {

                    updateProgressbar($modalProgressBar,$modalProgressBarNo,termCounter,numberOfTerms);
            }
    });

      //reset messages just in case :)
        resetMessages();

    //Dinamic button
    //SUBMIT          = $('.message:not(.true):not(.false) button')
    //FALSE (RETRY)   = $('.message.false button')
    //TRUE (CONTINUE) = $('.message.true button')

    //SUBMIT button click
    $(document).on("click",'.message:not(.false):not(.true) button',function(e) {
        e.preventDefault();

        // console.log("BTN SUBMIT");

        // Increment Question counter
            GAQuestionCounter++;

        // clear previous messeges
        resetMessages();

        var currentQuestion = $('.current');

            if (currentQuestion.hasClass('selection')) {
                    testSelection(currentQuestion);
            }
            else if (currentQuestion.hasClass('sortable')) {
                    testSortable(currentQuestion);
                    //remove remaining answer options
                    currentQuestion.find('.drags').css("display","none");
            }
            else if (currentQuestion.hasClass('term')) {
                    testTerm(currentQuestion);
            }
            else if (currentQuestion.hasClass('slider-selection')) {
                    testSlider(currentQuestion);
            }
            else if (currentQuestion.hasClass('multiple-selection')) {
                    testMultipleSelection(currentQuestion);
            }
            else if (currentQuestion.hasClass('image-selection')) {
                    testImageSelection(currentQuestion);
            }
        });
    //RETRY button ( NEXT ) button
    $(document).on("click",'.message.false button',function(e) {
         e.preventDefault();
        /*
            - move .current to next question and hide previous
            - reset message and button
            - increment question counter
            - if last question select next modal ( add .active to modal and remove from parent #level)
        */
        $('.current').removeClass('current').hide()
            .nextAll('form:not(.alt-q):first').show().addClass('current');
        UnDimScreen();
        resetMessages();
        if (currentQuestion == numOfQuestions) {
            //Next section selection ( remove .active remove .current )
            activeLevel.removeClass('active')
                        .next().addClass('active');

            //Statistic
            //Increment incorrect answer counter
            numIncorrectAnswers++;
            //Write 0 for incorrect answer
            statisticDataObject[currentQuestion] = 0;

            //reset current question counter
            currentQuestion = 0;
            //reset progressbar
            resetProgressbar();
            //hide level info
            $levelInfo.hide();
            //reset all sliders to empty (BUG FIX)
            $( '.ui-slider-handle' ).text( '' );

            // User finished the quiz
            quizCanceled = false;
            // Get time of quiz completion
            getQuizCompleteTime();
            // console.log("Quiz completed");

            // Hide progressbar after last question
            $mainProgressBarNo.css("display","none");

            // ga('send', 'event', 'Question '+ GAQuestionCounter, 'Incorrect answer' , 'User answer');
            // ga('send', 'event', 'Quiz Status', 'Compleded' , 'User ended quiz');
        }
        else
            {
                //Statistic
                //Increment incorrect answer counter
                numIncorrectAnswers++;
                //Write 0 for incorrect answer
                statisticDataObject[currentQuestion] = 0;

                if (numOfQuestions == 0 && numberOfQuestions )
                  numOfQuestions = numberOfQuestions;

                currentQuestion++;
                updateProgressbar($mainProgressBar,$mainProgressBarNo,currentQuestion,numOfQuestions);

                // ga('send', 'event', 'Question '+ GAQuestionCounter, 'Incorrect answer' , 'User answer');
        }
        //if current question is sortable shuffle answers
        $('.sortable.current').randomize('.retrieve-container');

    });

    //CONTINUE button
    $(document).on("click",'.message.true button',function(e) {
         e.preventDefault();
        /*
            - move .current to next question and hide previous
            - reset message and button
            - increment question counter
            - if last question select next modal ( add .active to modal and remove from parent #level)
        */
        $('.current').removeClass('current').hide()
            .nextAll('form:not(.alt-q):first').show().addClass('current');
        resetMessages();
        if (currentQuestion == numOfQuestions) {
            //Next section selection ( remove .active remove .current )
            activeLevel.removeClass('active')
                        .next().addClass('active');

            //Statistic
            //Increment correct answer counter
            numCorrectAnswers++;
            //Write 1 for correct answer
            statisticDataObject[currentQuestion] = 1;

            //reset current question counter
            currentQuestion = 0;
            //reset progressbar
            resetProgressbar();
            //hide level info
            $levelInfo.hide();
            //reset all sliders to empty (BUG FIX)
            $( '.ui-slider-handle' ).text( '' );

            // User finished the quiz
            quizCanceled = false;
            // Get time of quiz completion
            getQuizCompleteTime();
            // console.log("Quiz completed");

            // Hide progressbar after last question
            $mainProgressBarNo.css("display","none");

            // ga('send', 'event', 'Question '+ GAQuestionCounter, 'Correct answer' , 'User answer');
            // ga('send', 'event', 'Quiz Status', 'Compleded' , 'User ended quiz');
        }
        else
            {
                //Statistic
                //Increment correct answer counter
                numCorrectAnswers++;
                //Write 1 for correct answer
                statisticDataObject[currentQuestion] = 1

                currentQuestion++;
                updateProgressbar($mainProgressBar,$mainProgressBarNo,currentQuestion,numOfQuestions);

                // ga('send', 'event', 'Question '+ GAQuestionCounter, 'Correct answer' , 'User answer');

        }
        //if current question is sortable shuffle answers
        $('.sortable.current').randomize('.retrieve-container');

        // console.log("BTN CONTINUE");

        // console.log(statisticDataObject);


    });

    //Social and Video links
    //get base url
    var docOrigin = document.location.origin;

    $('.fbl').attr('href','http://www.facebook.com/sharer.php?s=100&p[url]='+ docOrigin +'/quiz/');
    var share_text = escape("Do you know where you're safe from BPA? Visit Facts About BPA and take the quiz to find out ");
    $('.twl').attr('href','https://twitter.com/intent/tweet?text='+ share_text + docOrigin +'/quiz/');

    // $('.social .lnl1').attr('href','http://www.linkedin.com/shareArticle?mini=true&url='+ docOrigin +'/level1.html&title=RailroadQuiz&source=SOURCE/DOMAIN');


    //Play video
    $('.start-level-video .test-img img').click(function(){
        $this = $(this);
        var parent = $this.parents('.start-level-video');

        //hide image
        $this.css('display','none');

        // check if in MODAL (no start-level class)
            if (parent.length == 0) {
                parent = $this.parents('.modal-body');
            }

           //Load video for level1
            if ($this.hasClass('video1')) {

                parent.find('.test-video')
                        .html(  '<iframe class="embed-responsive-item myVideo" '+
                                        'src="https://player.vimeo.com/video/180750612?color=ffc000&title=0&byline=0&portrait=0" width="640" height="360" '+
                                        'frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>'+
                                '</iframe>');
            }
            //Load video for level3
            else if ($this.hasClass('video2')) {

                parent.find('.test-video')
                        .html(  '<iframe class="embed-responsive-item myVideo" '+
                                        'src="https://player.vimeo.com/video/182105693?title=0&byline=0&portrait=0" width="640" height="360" '+
                                        'frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>'+
                                '</iframe>');
            }
    });

    //On Modal OPEN
    //reset counter for modal
    $termsModal.on('show.bs.modal', function (e) {
        //on firs modal open set values in progressbar
        if (modalOpend == false) {
            termCounter = 1;
            updateProgressbar ($modalProgressBar,$modalProgressBarNo,termCounter,numberOfTerms);
        }
        modalOpend = true;
    });

    //On Modal CLOSE
    //stop video play
    $videoModal.on('hidden.bs.modal', function (e) {
        var $if = $(e.delegateTarget).find('iframe');
        var src = $if.attr("src");
            $if.attr("src", '/empty_video.html');
            $if.attr("src", src);
    })

    // TIMER
    // (uses Global timerStart/End variables)
    function getQuizCompleteTime() {
        timerEnd = $.now();
        var timeOfQuizCompletion = parseInt((timerEnd - timerStart)/1000);
        statisticDataObject[0] = timeOfQuizCompletion;
    }



/*ANSWER TESTING FUNCTIONS*/

// Test Selection question
function testSelection(question) {

    var answer = question.find(':radio:checked');

    if (answer.data('value') == 1) {
        trowMessage(question,true);
    }
    else {
        trowMessage(question,false);
    }
}
//Test Sortable question
function testSortable(question) {

    var correct = 0;
    var incorrect = 0;
    var questionCounter= 0;
    var result = "";

    question.find('.droppable').each(function(index) {
        questionCounter++;

        var parent_value = $(this).data('value');
        var child_value = $(this).find('span').data('value');

        if (parent_value == child_value ) {
            $(this).find('span').css("color","green");
            correct++;
        }
        else {
            $(this).find('span').css("color","red");
            incorrect++;
        }
    });

    // resultErr = incorrect +'/'+ questionCounter;
    result = correct +'/'+ questionCounter;

    //if all correct trow correct message with result
    if (incorrect == 0) {
        trowMessage(question,true,result);
    }
    else {
        trowMessage(question,false,result);
    }
}

//Test Term question
function testTerm(question) {

    var inputText = question.find('input:text');
    var userAnswer = inputText.val();

    // addapt user input string to attribute standard
    userAnswer = adaptUserAnswer(userAnswer);
    var correctAnswer = inputText.data('value');

    if (userAnswer == correctAnswer) {
        trowMessage(question,true);
    }
    else {
        trowMessage(question,false);
    }
}
// adapt user imput string for testing
function adaptUserAnswer(str) {
    str = str.replace(/\s+/g, '');
    return str;
}

//Test slider
function testSlider(question) {

    var inputValue = question.find('input:text').val();
    var correctAnswer = question.find('.slider').data('value');

    if (inputValue == correctAnswer) {
        trowMessage(question,true);
    }
    else {
        trowMessage(question,false);
    }

}

//Test multiple selection
function testMultipleSelection(question) {

    // var answers = question.find('input[type="checkbox"]:checked');
    var answers = question.find(':checkbox:checked');
    var choices = question.find(':checkbox').length;
    var correct = 0;
    var incorrect = 0;
    var result = "";
    var badresult = "";
    var checked = 0;

    answers.each(function(i){

        if ($(this).is(':checked')) {
            checked++;
        }

        if ($(this).data('value') == 1 ){
         correct++;
        }
        else {
            incorrect++;
        }
    });

    badresult = correct +'/'+ choices;
    result = correct +'/'+ correct;

        //if all correct trow correct message with result
        if (incorrect == 0 && checked >=2) {
            trowMessage(question,true,result);
        }
        else {
            trowMessage(question,false,badresult);
        }
}

// test Image Selection question
function testImageSelection(question) {

    var answer = question.find(':radio:checked');

    if (answer.data('value') == 1) {
        trowMessage(question,true);
    }
    else {
        trowMessage(question,false);
    }
}

function trowMessage(message,msgType,score) {

    //defoult setup if parameter ommited
    if (score === undefined) { score = ''}
    if (msgType === undefined) { msgType = true}

    var $msg_correct = message.children('.msg-correct').html();
    var $msg_incorrect = message.children('.msg-incorrect').html();

    //if messages not defined set defoult
    if ($msg_correct === undefined) { $msg_correct = "(You did great.)"; }
    // if (msg_incorrect === undefined){ msg_incorrect = "(But don’t feel too bad, review the terms again)"; }

    var message = $('.message');
    var content = $('.content');

    //if message type is = Correct answer
    if (msgType == true) {
        // clear previous state and add new
        message.removeClass('false')
                .addClass('true');

        content.find('h2')
                .text("Correct:" + score)
                .next('p').append($msg_correct);
        message.find('button').text('Continue');

    }
    else if (msgType == false) {
        message.removeClass('true')
                .addClass('false');

        content.find('h2').text("Incorrect:" + score)
                .next('p').append($msg_incorrect);
        message.find('button').text('Next');

        DimScreen();
    }
}

//count Questions in level
function countQuestions(level) {
    numOfQuestions = level.children('form:not(.alt-q)').size();
    var questionId = 0;
    level.find('form').each(function(i) {
      var $this = $(this);
      if (!$this.hasClass('alt-q')) {
        questionId++;
      }
      $this.attr('data-qid', questionId);
    });

    return numOfQuestions;
}

//update progresbarr
function updateProgressbar(barID,barNo,num,max) {
    // update text label
    barNo.text(num + '/' + max);
    // calc bar percent value
    var val = (num/max) *100;
    //update bar
    barID.progressbar({
      value: val
    });

}

//update level counter
function updateLevelCounter(level) {
    $('#lvl-info').find('span').text(level);
}

/*RESETS*/

function resetMessages() {

    var message = $('.message');

    message.removeClass('true')
            .removeClass('false')
            .find('h2').text("")
            .next('p').text("");
    message.find('button').text("Submit");
}

//Reset previous user inputs
function resetQuestionInputs() {
    $('label').removeAttr('style');
    $('input:checkbox').removeAttr('checked');
    $('input:radio').removeAttr('checked');
    $('input:text').val('');
    $('.drags').css("display","flex");
    $('.drag').find('span').css("color","");
    revertDroppableItems();
    resetSliderItem();
}

function resetProgressbar() {
    $('.progres-number').text("0/0");
    //update bar
    $( "#progressbar" ).progressbar({
      value: 0
    });
}

//sort dragable back to footer (reset to normall state)
function revertDroppableItems() {
    $currentQuestion = $('.current');
    $droped = $currentQuestion.find('.droppable').find('.drag');
    $container = $currentQuestion.find('.retrieve-container:empty');
    $droped.each(function(index) {
        $(this).appendTo($container[index]);
    });
    //re enable accept drop
    $currentQuestion.find('.droppable').droppable( "enable" );
}

//Reset slider to 0
function resetSliderItem() {
    $currentQuestion = $( '.current' );
    $currentQuestion.find( '[id^=amount]' ).val( 0 );
    $currentQuestion.find( '.ui-slider-handle' ).text( 0 )
                                                .css("left","");
}

// UX DIM SCREEN
//Dim questions
function DimScreen () {
    $('form').css('opacity','0.2');
}
//UnDim questions
function UnDimScreen () {
    $('form').css('opacity','1');
}

//Randomize dragable answers position
$.fn.randomize = function(selector){
    (selector ? this.find(selector) : this).parent().each(function(){
        $(this).children(selector).sort(function(){
            return Math.random() - 0.5;
        }).detach().appendTo(this);
    });

    return this;
};


    $('.menu-hamburger a').click(function(){
        // console.log("click");
        if($(this).hasClass('active-menu')) {
            $('#site-navigation').slideUp();
            $(this).removeClass('active-menu');
        } else {
            $('#site-navigation').slideDown();
            $(this).addClass('active-menu');
        }
    });

});